<section aria-live="polite" [attr.aria-busy]="!(relatedCardsLoaded$ | async)">
    <div *ngFor="let card of typeTravelcardCards$ | async; let even = even;" class="row-items table-content"
        [ngClass]="{ 'even': even }" (click)="relatedCardSelected(card)" (keydown.enter)="relatedCardSelected(card)"
        role="link" tabindex="0">

        <div class="col-item w1 ">
            <span role="img" alt="" class="icon"
                [ngClass]="{ 'icon-card': !card.email , 'icon-mail': card.is_card == 'N' && card.email }"></span>
        </div>

        <div class="col-item w9">
            <span *ngIf="card.name && card.name !== card.card_nr" class="title-card">{{ card.name }}</span>
            <span *ngIf="card.card_nr"
                [ngClass]="{ 'number-card-only': card.name === card.card_nr, 'number-card': card.name !== card.card_nr }">{{
                card.card_nr }}</span>
            <span class="amount-card-mob" *ngIf="!card.blocked">{{card.wallet_balance}}{{appStartupService.getCurrency() | translate
                }}</span>
            <span class="amount-card-mob" *ngIf="card.blocked">{{'RELATED_CARD_LIST_LABEL_CARD_BLOCKED' |
                translate}}</span>
        </div>

        <div class="col-item w2 desktop-right amount-card">
            <span class="amount-card-desk" *ngIf="!card.blocked">{{card.wallet_balance}}
                {{appStartupService.getCurrency() | translate }}</span>
            <span class="amount-card-desk" *ngIf="card.blocked">{{'RELATED_CARD_LIST_LABEL_CARD_BLOCKED' |
                translate}}</span>
            <span role="img" alt="" class="icon icon-arrow-right-link"></span>
        </div>
    </div>
</section>

<ridango-ui-basic-loading-spinner [ariaLabel]="'LOADER_LOADING_ARIA_LABEL' | translate"
    *ngIf="!(relatedCardsLoaded$ | async)">
</ridango-ui-basic-loading-spinner>
